module.exports = __webpack_public_path__ + "img/i201.ed952fa9.png";